"use strict";
var stickyCta = document.getElementsByClassName("sticky-cta-button")[0];
if (typeof stickyCta != "undefined") {
    stickyCta.style.display = "none";
    window.onscroll = function () {
        var topCta = document.getElementsByClassName("top-cta")[0];
        var footer = document.getElementsByClassName("footer")[0];
        var boundingTopCta = topCta.getBoundingClientRect();
        var boundingFooter = footer.getBoundingClientRect();
        if (
        // Hide side CTA button when top CTA button or the footer is visible
        (window.innerWidth <= 769 &&
            (boundingFooter.top <= window.innerHeight ||
                boundingTopCta.bottom >= 20)) ||
            (window.innerWidth > 769 &&
                (boundingTopCta.bottom >= 20 ||
                    boundingFooter.top <= window.innerHeight / 2))) {
            stickyCta.style.display = "none";
        }
        else {
            stickyCta.style.display = "flex";
        }
    };
}
